export default "__VITE_ASSET__DqckYACL__"